<template>
  <div id="order-product-list">
    <div class="mt-4 _fs-20">
      เลือกแพ็กเกจบรอดแคสต์ที่คุณต้องการ
    </div>
    <v-divider class="my-4"></v-divider>
    <order-package-plan-product
      :disabled="disabled"
      :package-plan="packagePlan"
      @update:package-plan="updateSync('package-plan', $event)"
    >
    </order-package-plan-product>

    <template v-if="packagePlan">
      <div class="mt-4 _fs-20">
        เลือกจำนวนเดือนที่คุณต้องการ
      </div>
      <v-divider class="my-4"></v-divider>
      <order-package-month-product
        :disabled="disabled"
        :package-plan="packagePlan"
        :package-month="packageMonth"
        :products="products"
        @update:package-month="updateSync('package-month', $event)"
      >
      </order-package-month-product>
    </template>

    <template v-if="packageMonth">
      <div class="mt-4 _fs-20">
        เลือกวันที่ต้องการเปิดใช้งานแพ็กเกจ
      </div>
      <v-divider class="my-4"></v-divider>
      <base-card>
        <v-row>
          <v-col
            cols="12"
            md="6">
            <base-date-picker
              :disabled="disabled"
              :value="packageStartedAt"
              :min="minDate"
              :max="maxDate"
              label="วันที่เปิดใช้งานแพ็กเกจ"
              hide-details
              @input="updateSync('package-started-at', $event)"
            >
            </base-date-picker>
          </v-col>
          <v-col
            cols="12"
            md="6">
            <base-date-picker
              disabled
              :value="packageExpired"
              label="วันที่แพ็กเกจหมดอายุ"
              hide-details
              input-class="_green--text"
            >
            </base-date-picker>
          </v-col>
          <v-col
            cols="12">
            <div class="mt-4 error--text _fs-14">
              <div>หมายเหตุ</div>
              <div>
                * กรณีแจ้งวันเริ่มใช้งานเป็น วันหยุด หรือวันนักขัตฤกษ์
                ระบบจะดำเนินการเปิดให้บริการในวันทำการถัดไป
              </div>
              <div>
                * สำหรับลูกค้าที่ย้ายมาจาก Agency อื่น หากมีแพ็กเกจอยู่แล้ว
                จะสามารถเริ่มใช้งานได้ในเดือนถัดไป
              </div>
              <div>
                * แพ็กเกจสามารถเริ่มวันใดของเดือนก็ได้แต่แนะนำให้เริ่มในวันที่ 1 เพราะ LINE
                Thailand จะมีการตัดวันใช้งานในวันสิ้นเดือนเสมอ (เช่นเริ่มในวันที่ 16 มีนาคม
                อายุการใช้งานของเดือนแรกจะใช้ได้ตั้งแต่วันที่ 16-31 มีนาคม)
              </div>
            </div>
          </v-col>
        </v-row>
      </base-card>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'OrderPackageProductList',
  components: {
    BaseCard: () => import('@/components/BaseCard.vue'),
    BaseDatePicker: () => import('@/components/BaseDatePicker.vue'),
    OrderPackagePlanProduct: () => import('@/components/OrderPackagePlanProduct.vue'),
    OrderPackageMonthProduct: () => import('@/components/OrderPackageMonthProduct.vue')
  },
  props: {
    products: {
      type: Array,
      default: () => []
    },
    packagePlan: {
      type: String,
      default: ''
    },
    packageMonth: {
      type: Number,
      default: 0
    },
    packageStartedAt: {
      type: [Date, String],
      default: ''
    },
    minPackageStartedAt: {
      type: Date,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      maxDate: '',
      minDate: ''
    }
  },
  computed: {
    ...mapGetters({
      MAXIMUM_PERIOD_PRE_ORDER: 'SystemConfig/GET_MAXIMUM_PERIOD_PRE_ORDER'
    }),
    packageExpired() {
      return this.$utils.createDayjsDate(this.packageStartedAt)
        .add((this.packageMonth - 1), 'month')
        .endOf('month')
        .toDate()
    }
  },
  mounted() {
    this.minDate = this.$utils.createDayjsDate(this.minPackageStartedAt)
      .toDate()
    this.maxDate = this.$utils.createDayjsDate(this.minPackageStartedAt)
      .add(this.MAXIMUM_PERIOD_PRE_ORDER.value, this.MAXIMUM_PERIOD_PRE_ORDER.unit)
      .toDate()
  },
  methods: {
    updateSync(field, value) {
      this.$emit(`update:${field}`, value)
    }
  }
}
</script>
